import { notification } from 'antd';
import { IGerenciarMunicipios, IItemDetalhesMunicipio, IPeriodoReprocessar } from '../interface';
import { useCallback, useRef, useState } from 'react';

import axios from 'axios';
import GerenciarMunicipiosService from '../../../services/http/services/ConfiguracoesReceitas/GerenciarMunicipiosService';

export const useGerenciarMunicipios = () => {
    const [response, setResponse] = useState<IGerenciarMunicipios | null>(null);
    const [loading, setLoading] = useState(false);
    const [loadingRegraModal, setLoadingRegraModal] = useState(false);

    const signalRef = useRef(axios.CancelToken.source());

    const getGerenciarMunicipios = useCallback(async () => {
        setLoading(true);
        try {
            const data = await GerenciarMunicipiosService.getGerenciarMunicipios(signalRef.current.token);
            setResponse(data);
        } catch (error) {
            if (!axios.isCancel(error)) {
                notification.error({
                    message: 'Erro',
                    description: 'Erro ao carregar municípios!'
                });
            }
        } finally {
            setLoading(false);
        }
    }, []);

    const [loadingDelete, setLoadingDelete] = useState(false);

    const deleteMunicipio = useCallback(async (id_ibge: number, sistema_slug: string) => {
        setLoadingDelete(true);
        try {
            await GerenciarMunicipiosService.deleteMunicipio(id_ibge, sistema_slug);
            notification.success({
                message: 'Sucesso',
                description: 'Município apagado do sistema com sucesso!'
            });
            await getGerenciarMunicipios();
        } catch (error) {
            notification.error({
                message: 'Erro',
                description: 'Erro ao apagar município!'
            });
        } finally {
            setLoadingDelete(false);
        }
    }, [getGerenciarMunicipios]);

    const [loadingDetalhes, setLoadingDetalhes] = useState(false);
    const [detalhesMunicipio, setDetalhesMunicipio] = useState<IItemDetalhesMunicipio | null>(null);

    const getDetalhesMunicipio = useCallback(async (id_ibge: number, sistema_slug: string) => {
        setLoadingDetalhes(true);
        try {
            const data = await GerenciarMunicipiosService.getDetalhesMunicipio(id_ibge, sistema_slug);
            setDetalhesMunicipio(data);
            return data;
        } catch (error) {
            notification.error({
                message: 'Erro',
                description: 'Erro ao carregar detalhes do município!'
            });
            return null;
        } finally {
            setLoadingDetalhes(false);
        }
    }, []);

    const [loadingReprocessar, setLoadingReprocessar] = useState(false);

    const reprocessarMunicipio = useCallback(async (id_ibge: number, sistema_slug: string, periodos: IPeriodoReprocessar[]) => {
        setLoadingReprocessar(true);
        try {
            await GerenciarMunicipiosService.reprocessarMunicipio(id_ibge, sistema_slug, periodos);
            notification.success({
                message: 'Sucesso',
                description: 'Solicitação de reprocessamento enviada com sucesso!'
            });
            await getGerenciarMunicipios();
            return true;
        } catch (error) {
            notification.error({
                message: 'Erro',
                description: 'Erro ao enviar solicitação de reprocessamento!'
            });
            return false;
        } finally {
            setLoadingReprocessar(false);
        }
    }, [getGerenciarMunicipios]);

    return {
        loading,
        loadingDelete,
        response,
        loadingRegraModal,
        getGerenciarMunicipios,
        deleteMunicipio,
        loadingDetalhes,
        detalhesMunicipio,
        getDetalhesMunicipio,
        loadingReprocessar,
        reprocessarMunicipio,
    };
};
